import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { TextField as TextFieldShell } from '@e3dc-react/shell/Elements/InputFields'
import { SettingsBox } from 'src/Elements/Data'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'

type EvseType = 'eebus' | 'modbusTcp'

interface EvseDeviceInformationProps {
  evseType: EvseType
  brand: string
  reference: string
  deviceReference?: string
}

export const CommonEvseDeviceInformation: React.FC<EvseDeviceInformationProps> = ({ evseType, brand, reference, deviceReference }) => {
  const { t } = useCustomTranslation()
  const {
    featureFlags: { useEvseWittyLinkSubTypes },
  } = useFeatureFlagsContext()

  if (useEvseWittyLinkSubTypes) {
    const displayedReference = evseType === 'modbusTcp' ? deviceReference || reference : reference

    return (
      <>
        <SettingsBox
          title={t('installation.productEditor.brand')}
          suffix={
            <TextFieldShell sx={{ width: ['100%', 'auto'] }} label={t('installation.productEditor.brand')} value={brand} disabled fullWidth={false} />
          }
        />
        <SettingsBox
          title={t('installation.productEditor.reference')}
          suffix={
            <TextFieldShell
              sx={{ width: ['100%', 'auto'] }}
              label={t('installation.productEditor.reference')}
              value={displayedReference}
              disabled
              fullWidth={false}
            />
          }
        />
      </>
    )
  }

  const deviceTypeLabel =
    evseType === 'eebus' ? 'installation.submeterEditor.mediaTypeOptions.EEBus' : 'installation.submeterEditor.mediaTypeOptions.modbusTCP'

  return (
    <SettingsBox
      title={t('installation.evseEditor.deviceType')}
      suffix={
        <TextFieldShell
          sx={{ width: ['100%', 'auto'] }}
          value={t(deviceTypeLabel)}
          label={t('installation.evseEditor.deviceType')}
          disabled
          fullWidth={false}
        />
      }
    />
  )
}
